import { EdsPromoToken, PromoToken } from '@bpos/common/bet-placement';
import { DecisionSource } from '@bpos/v1/over-ask';

import { IBasePrice, IBetslipPickStorage, PickOddsState } from '../../core/picks/pick-models';
import { OverAskBet, OverAskFlowState, OverAskMarketTypeChange } from '../../model/over-ask/over-ask';
import { SlipId } from '../bet-generation/models';
import { SlipType } from '../bet-generation/slip-type';

export interface OverAskReviewState {
    remainingSeconds: number;
    offerChanged: boolean;
}

export interface OverAskErrorCreator {
    newStakeHint: number;
    type: string;
}

export interface IBetslipOverAskState {
    flowState: OverAskFlowState;
    offerId: string;
    bets: OverAskBet[];
    reviewState: OverAskReviewState;
    error: OverAskErrorCreator;
    requestId: string;
    parentRequestId?: string;
    decisionSource?: DecisionSource;
    isofferModified: boolean;
}

export const defaultOverAskState = Object.freeze({
    flowState: OverAskFlowState.None,
    offerId: '',
    bets: [],
    reviewState: {
        remainingSeconds: 0,
        offerChanged: false,
    },
    error: { type: '', newStakeHint: 0 },
    requestId: '',
    parentRequestId: '',
    isofferModified: false,
}) as IBetslipOverAskState;

interface OverAskPickChangesSavedState {
    price?: IBasePrice; // Change in the price
    marketType?: OverAskMarketTypeChange; // Change in market type.
}

interface OverAskPickSavedState {
    index: number;
    pick: IBetslipPickStorage;
    isEachWay: boolean;
    isBanker: boolean;
    price: IBasePrice;
    oddsState: PickOddsState; // We don't need to save this status, after page refresh we need to get refresh one from CDS.
    changes: OverAskPickChangesSavedState;
}

interface OverAskBetChangeSavedState {
    stake?: number;
}

export interface OverAskBetSavedState {
    slipId: SlipId;
    index: number;
    stake: number;
    type: SlipType;
    isRemoved: boolean;
    picks: OverAskPickSavedState[];
    changes: OverAskBetChangeSavedState;
    promoTokens: PromoToken[];
    edsPromoTokens: EdsPromoToken[];
}

export interface IBetslipOverAskSavedState {
    flowState: OverAskFlowState;
    offerId: string;
    bets: OverAskBetSavedState[];
    error: OverAskErrorCreator;
    requestId: string;
    parentRequestId?: string;
    decisionSource?: DecisionSource;
    isofferModified: boolean;
}

export const emptyOverAskSavedState: IBetslipOverAskSavedState = {
    flowState: OverAskFlowState.None,
    offerId: '',
    bets: [],
    error: { type: '', newStakeHint: 0 },
    requestId: '',
    parentRequestId: '',
    isofferModified: false,
};
